module.exports = "https://la-static.vkplay.ru/promo/thefirst/img/scroll-3.6ee3cfbe.png";